import React, { useEffect } from "react";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { yupResolver} from '@hookform/resolvers/yup'
import { getErrToast } from "@/utils/helpers";
import clsx from "clsx";
type Props = {
  children: React.ReactNode;
  initialValues: any;
  isValidate: boolean
  validateSchema: any;
  className ?:string
  onSubmit : (data : any, methods: any)=> void
};

const RHFWrapper = ({
  children,
  initialValues,
  isValidate,
  validateSchema,
  className,
  onSubmit,
//   onError,
}: Props) => {
  const methods = useForm({
    defaultValues: initialValues,
    
    ...(isValidate ? {resolver : yupResolver(validateSchema) } : {})
  
  });
  const { handleSubmit, reset } = methods;


  useEffect(()=> {
   
    initialValues && reset(initialValues);
  },[JSON.stringify(initialValues)])
  
  return (
    <FormProvider {...methods}>
      <form
      className={clsx( className, 'relative')}
        onSubmit={handleSubmit(
          (data)=>onSubmit(data, methods),
          (err :any) => {
            let errFields= Object.keys(err).join(", ")
            getErrToast("Error in form fields "+ errFields)
            console.log("ERR : ", err);
          },
        )}
      >
        {children}
      </form>
    </FormProvider>
  );
};

export default RHFWrapper;
